'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var hexToComponents = function hexToComponents(hex) {
  var regex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  if (regex) return regex.slice(1, 4);

  return ['ff', 'ff', 'ff'];
};

exports.default = hexToComponents;


//////////////////
// WEBPACK FOOTER
// ./node_modules/color-invert/lib/hexToComponents.js
// module id = 50
// module chunks = 0